import Direct from '@assets/direct_diposit.svg';
import InstantTransfer from '@assets/instant-transfer.svg';
import PayPal from '@assets/payPal.svg';
import Venmo from '@assets/venmo.svg';
import Visa from '@assets/Visa_card.svg';
import { TREMENDOUS_HOVER } from '@constants/claim';

import Origin from '@assets/origin.svg';
import { isEmail, isOnlyNumber, isValiate } from '../../utils';

export const TITLE_TEXT = 'Select how you get paid';
export const MODAL_TIPS = "Please make sure to provide accurate information below, otherwise you'll fail to receive your payout.";
export const VENMO_TYPE_EMAIL = 'email';
export const VENMO_TYPE_PHONE = 'phone';

export const DIRECT_DEPOSIT_ATTR = 'directDepositPayAccount';
export const INSTANT_TRANSFER_ATTR = 'instantTransferPayAccount';
export const PAYPAL_ATTR = 'paypalPayAccount';
export const VENMO_ATTR = 'venmoPayAccount';

export const accountTypeOptions = [{
  value: 'CHECKING',
  label: 'CHECKING',
},
{
  value: 'SAVING',
  label: 'SAVING',
}];

export const accountClassOptions = [{
  value: 'PERSONAL',
  label: 'PERSONAL',
},
{
  value: 'BUSINESS',
  label: 'BUSINESS',
}];

export const methodName = {
  DD: 'Direct Deposit',
  IT: 'Instant Transfer',
  PP: 'PayPal',
  VV: 'Venmo',
};

export const US_COUNTRY_OPTIONS = [{
  value: 'US',
  label: 'United States',
}];

export const US_STATE_OPTIONS = [
  {
    value: 'Alabama',
    label: 'Alabama',
  },
  {
    value: 'Alaska',
    label: 'Alaska',
  },
  {
    value: 'American Samoa',
    label: 'American Samoa',
  },
  {
    value: 'Arizona',
    label: 'Arizona',
  },
  {
    value: 'Arkansas',
    label: 'Arkansas',
  },
  {
    value: 'California',
    label: 'California',
  },
  {
    value: 'Colorado',
    label: 'Colorado',
  },
  {
    value: 'Connecticut',
    label: 'Connecticut',
  },
  {
    value: 'Delaware',
    label: 'Delaware',
  },
  {
    value: 'District of Columbia',
    label: 'District of Columbia',
  },
  {
    value: 'Micronesia',
    label: 'Micronesia',
  },
  {
    value: 'Florida',
    label: 'Florida',
  },
  {
    value: 'Georgia',
    label: 'Georgia',
  },
  {
    value: 'Guam',
    label: 'Guam',
  },
  {
    value: 'Hawaii',
    label: 'Hawaii',
  },
  {
    value: 'Idaho',
    label: 'Idaho',
  },
  {
    value: 'Illinois',
    label: 'Illinois',
  },
  {
    value: 'Indiana',
    label: 'Indiana',
  },
  {
    value: 'Iowa',
    label: 'Iowa',
  },
  {
    value: 'Kansas',
    label: 'Kansas',
  },
  {
    value: 'Kentucky',
    label: 'Kentucky',
  },
  {
    value: 'Louisiana',
    label: 'Louisiana',
  },
  {
    value: 'Maine',
    label: 'Maine',
  },
  {
    value: 'Marshall Islands',
    label: 'Marshall Islands',
  },
  {
    value: 'Maryland',
    label: 'Maryland',
  },
  {
    value: 'Massachusetts',
    label: 'Massachusetts',
  },
  {
    value: 'Michigan',
    label: 'Michigan',
  },
  {
    value: 'Minnesota',
    label: 'Minnesota',
  },
  {
    value: 'Mississippi',
    label: 'Mississippi',
  },
  {
    value: 'Missouri',
    label: 'Missouri',
  },
  {
    value: 'Montana',
    label: 'Montana',
  },
  {
    value: 'Nebraska',
    label: 'Nebraska',
  },
  {
    value: 'Nevada',
    label: 'Nevada',
  },
  {
    value: 'New Hampshire',
    label: 'New Hampshire',
  },
  {
    value: 'New Jersey',
    label: 'New Jersey',
  },
  {
    value: 'New Mexico',
    label: 'New Mexico',
  },
  {
    value: 'New York',
    label: 'New York',
  },
  {
    value: 'North Carolina',
    label: 'North Carolina',
  },
  {
    value: 'North Dakota',
    label: 'North Dakota',
  },
  {
    value: 'Northern Mariana Islands',
    label: 'Northern Mariana Islands',
  },
  {
    value: 'Ohio',
    label: 'Ohio',
  },
  {
    value: 'Oklahoma',
    label: 'Oklahoma',
  },
  {
    value: 'Oregon',
    label: 'Oregon',
  },
  {
    value: 'Palau',
    label: 'Palau',
  },
  {
    value: 'Pennsylvania',
    label: 'Pennsylvania',
  },
  {
    value: 'Puerto Rico',
    label: 'Puerto Rico',
  },
  {
    value: 'Rhode Island',
    label: 'Rhode Island',
  },
  {
    value: 'South Carolina',
    label: 'South Carolina',
  },
  {
    value: 'South Dakota',
    label: 'South Dakota',
  },
  {
    value: 'Tennessee',
    label: 'Tennessee',
  },
  {
    value: 'Texas',
    label: 'Texas',
  },
  {
    value: 'Utah',
    label: 'Utah',
  },
  {
    value: 'Vermont',
    label: 'Vermont',
  },
  {
    value: 'Virgin Islands',
    label: 'Virgin Islands',
  },
  {
    value: 'Virginia',
    label: 'Virginia',
  },
  {
    value: 'Washington',
    label: 'Washington',
  },
  {
    value: 'West Virginia',
    label: 'West Virginia',
  },
  {
    value: 'Wisconsin',
    label: 'Wisconsin',
  },
  {
    value: 'Wyoming',
    label: 'Wyoming',
  },
  {
    value: 'Armed Forces Americas',
    label: 'Armed Forces Americas',
  },
  {
    value: 'Armed Forces Europe, Canada, Africa and Middle East',
    label: 'Armed Forces Europe, Canada, Africa and Middle East',
  },
  {
    value: 'Armed Forces Pacific',
    label: 'Armed Forces Pacific',
  },
];
const numberValidator = (_, value) => {
  if (value && !isOnlyNumber(value)) {
    return Promise.reject(new Error('Please input the number'));
  }
  return Promise.resolve();
};

const emailValidator = (_, value) => {
  if (value && !isEmail(value)) {
    return Promise.reject(new Error("That doesn't look like an email address"));
  }
  return Promise.resolve();
};

// All payment methods map
export const paymentMethods = {
  shopify_refund: {
    value: 'shopify_refund',
    title: 'Return to original payment method',
    time: 'Processing time: 1-3 business days ',
    icon: Origin,
  },
  tremendous: {
    value: 'tremendous',
    title: 'Virtual Visa card',
    time: 'Processing time: within 1 hour',
    icon: Visa,
    hover: TREMENDOUS_HOVER,
  },
  gently_refund: {
    value: 'gently_refund',
    title: 'Return to original payment method',
    time: 'Processing time: 1-3 business days ',
    icon: Origin,
  },
  direct_deposit: {
    value: 'direct_deposit',
    title: 'Direct Deposit',
    time: 'Processing time: 1-3 business days',
    icon: Direct,
    hasModal: true,
    fields: [{
      type: 'input',
      value: 'name',
      label: 'Name on account',
    },
    {
      type: 'input',
      value: 'routingNumber',
      label: 'Routing number',
      rules: [
        {
          validator: (_, value) => {
            if (value && !isOnlyNumber(value)) {
              return Promise.reject(new Error('Please input the number'));
            }
            if (value && value.length !== 9) {
              return Promise.reject(new Error('The length of routing number is nine'));
            }
            return Promise.resolve();
          },
        },
      ],
    },
    {
      type: 'input',
      value: 'accountNumber',
      label: 'Account number',
      rules: [
        {
          validator: numberValidator,
        },
      ],
    },
    {
      type: 'select',
      value: 'accountType',
      label: 'Account type',
      options: accountTypeOptions,
      placeholder: 'Select',
    },
    {
      type: 'select',
      value: 'accountClass',
      label: 'Account class',
      options: accountClassOptions,
    },
    ],
    attribute: DIRECT_DEPOSIT_ATTR,
  },
  instant_transfer: {
    value: 'instant_transfer',
    title: 'Instant Transfer',
    time: 'Processing time: within 1 hour',
    icon: InstantTransfer,
    subTitle: '(A 3% transaction fee will be deducted from your payout)',
    hasModal: true,
    fields: [{
      type: 'input',
      value: 'name',
      label: 'Name on account',
    }, {
      type: 'input',
      value: 'routingNumber',
      label: 'Routing number',
      rules: [
        {
          validator: numberValidator,
        },
      ],
    }, {
      type: 'input',
      value: 'accountNumber',
      label: 'Account number',
      rules: [
        {
          validator: numberValidator,
        },
      ],
    }, {
      type: 'select',
      value: 'accountType',
      label: 'Account type',
      options: accountTypeOptions,
    }, {
      type: 'input',
      value: 'address1',
      label: 'Street',
    }, {
      type: 'input',
      value: 'address2',
      label: 'Apartment, suite, etc. (optional)',
    }, {
      type: 'input',
      value: 'city',
      label: 'City',
    }, [{
      type: 'select',
      value: 'country',
      label: 'Country/region',
      options: US_COUNTRY_OPTIONS,
      // wrapperCol: { span: 6 },
    }, {
      type: 'select',
      value: 'state',
      label: 'State',
      options: US_STATE_OPTIONS,
      allowClear: true,
      // wrapperCol: { span: 6 },

    }, {
      type: 'input',
      value: 'zipcode',
      label: 'Postal code',
      // wrapperCol: { span: 6 },

    }]],
    attribute: INSTANT_TRANSFER_ATTR,
  },
  paypal: {
    value: 'paypal',
    title: 'PayPal',
    time: 'Processing time: within 1 hour',
    icon: PayPal,
    hasModal: true,
    fields: [{
      type: 'input',
      value: 'email',
      label: 'Email',
      rules: [
        {
          validator: emailValidator,
        },
      ],
    }],
    attribute: PAYPAL_ATTR,
  },
  venmo: {
    value: 'venmo',
    title: 'Venmo',
    time: 'Processing time: within 1 hour',
    icon: Venmo,
    hasModal: true,
    attribute: VENMO_ATTR,
    fields: [{
      type: 'input',
      value: 'venmoAccountNumber',
      label: 'Username',
      prefix: '@',
      rules: [
        {
          validator: (_, value) => {
            if (!value) {
              return Promise.reject(new Error('Please input the username'));
            }
            if (value && !isValiate(value)) {
              return Promise.reject(new Error('Your username should start with a letter and contain only letters, numbers, hyphen(-), and underscore(_) characters. It must be 5-30 characters long.'));
            }
            return Promise.resolve();
          },
        },
      ],
    }],
  },
};

/**
 * get payment method config
 * @param {Array} supportedPaymentMethod A dynamic array of payment methods from the interface
 * @returns {Array} More detailed array of payment metho
 */
export const getMethods = (supportedPaymentMethod) => {
  const list = supportedPaymentMethod.map((item) => ({ ...paymentMethods[item] }));
  if (!list.length) {
    list.push(paymentMethods.tremendous);
  }
  return list;
};
